import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../App';
import { canViewDeveloperQuality } from '../../access';

// Shared sub-navigation for the Code Review section.
export default function ReviewTabs() {
  const { user } = useAuth();
  const tabs = [
    { to: '/code-review', label: 'Configs', end: true },
    { to: '/code-review/runs', label: 'Runs' },
    { to: '/code-review/costs', label: 'Cost & Usage' },
    { to: '/code-review/rules', label: 'Rules' },
    { to: '/code-review/prompts', label: 'Prompts' },
    { to: '/code-review/monitor-report', label: 'Monitor Report' },
    ...(canViewDeveloperQuality(user)
      ? [{ to: '/code-review/developer-quality', label: 'Developer Quality' }]
      : []),
  ];
  return (
    <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid var(--border)', marginBottom: 20 }}>
      {tabs.map(t => (
        <NavLink key={t.to} to={t.to} end={t.end}
          className={({ isActive }) => isActive ? 'active' : ''}
          style={({ isActive }) => ({
            padding: '8px 14px', fontSize: 13, fontWeight: 600, textDecoration: 'none',
            color: isActive ? 'var(--accent)' : 'var(--text-secondary)',
            borderBottom: isActive ? '2px solid var(--accent)' : '2px solid transparent',
            marginBottom: -1,
          })}>
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
